module.exports = __webpack_public_path__ + "media/images/list_practice/2-01-384a261a6392d28b03227b9bcfefc57f.svg";